import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=7ef1fac0&"
import script from "./ValidationErrors.vue?vue&type=script&lang=js&"
export * from "./ValidationErrors.vue?vue&type=script&lang=js&"
import style0 from "./ValidationErrors.vue?vue&type=style&index=0&id=7ef1fac0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports